import {combineReducers} from 'redux'
import fetchReducer from 'reducers/fetchReducer'
import {actionTypes} from 'actions'

export default combineReducers({
  current: fetchReducer(actionTypes.TM.ROLES.CURRENT, {data: {}}),
})
